<template>
  <div :id="'echartringid'+configs.id" style="width: 100%; height: 100%"></div>
</template>

<script>
export default {
  name: 'echart-ring',
  props:{
    configs: [Object,Array,String]
    // calendarTypeOptions:Array,
    // sortOptions:Array,
    // temp:Object
  },
  data () {
    return {

      }
  },
  mounted(){
    // this.echartring()
  },
  methods:{
    echartring (data) {
      const $this=this
      const myEchartst = this.$echarts.init(document.getElementById('echartringid'+this.configs.id))
      let option = {
        title:{
          show:$this.configs.titleshow || true,
          text:$this.configs.text||'',
          textStyle:{
            color:'#F4F7FF',
            fontSize:'18px'
          },
          top: 5,
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '15%',
          left: 'left',
          orient:'vertical',
          textStyle:{
            color:'#F4F7FF'
          }
        },
        series: [
          {
            name: $this.configs.name,
            type: 'pie',
            top:$this.configs.seriestop||'19%',
            left:$this.configs.seriesleft||'15%',
            radius: ['30%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: true,
              formatter:`{b} \n{d}%`,
              textStyle:{
                color:'#F4F7FF'
              }
              // position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '21',
                fontWeight: 'bold'
              }
            },
            data: this.configs.seriesdata
          }
        ]
      }
      myEchartst.setOption(option,true)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/echart-ring.vue